/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_About_Coverage_Item4Inputs */

const ja_playdata_about_coverage_item4 = /** @type {(inputs: Playdata_About_Coverage_Item4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`国内eスポーツ業界にとって重要度が高いと独自判断したイベント/大会`)
};

const en_playdata_about_coverage_item4 = /** @type {(inputs: Playdata_About_Coverage_Item4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Events independently judged to be of importance to the domestic esports industry`)
};

/**
* | output |
* | --- |
* | "Events independently judged to be of importance to the domestic esports industry" |
*
* @param {Playdata_About_Coverage_Item4Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_about_coverage_item4 = /** @type {((inputs?: Playdata_About_Coverage_Item4Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_About_Coverage_Item4Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_about_coverage_item4(inputs)
	return en_playdata_about_coverage_item4(inputs)
});